import { store } from 'expo-router/build/global-state/router-store';

let lastPathname = '';
let previousPathname = '';

export const getStaticPathname = () => {
  try {
    const pathname = store?.getRouteInfo?.()?.pathname;
    if (pathname && pathname !== lastPathname) {
      previousPathname = lastPathname;
      lastPathname = pathname;
    }
    return pathname || lastPathname;
  } catch (_err) {
    // we have seen some race conditions where the above function is unavailable in race condition rapid modal popping analytics scenarios - this keeps it safe
    return lastPathname;
  }
};

export const getStaticPathAndSearch = () => {
  try {
    return store?.getRouteInfo?.()?.unstable_globalHref;
  } catch (_err) {
    // we have seen some race conditions where the above function is unavailable in race condition rapid modal popping analytics scenarios - this keeps it safe
    return previousPathname;
  }
};

export const getStaticReferrerPathname = () => previousPathname;
